export const RESET_PROFIT_AND_LOSS = 'RESET_PROFIT_AND_LOSS'
export const SET_PROFIT_AND_LOSS_DATES = 'SET_PROFIT_AND_LOSS_DATES'
